export default function Footer() {
  return (
    <footer className="bg-gradient-to-br from-gray-900 to-gray-800 text-white pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-4 gap-10 mb-12">
          {/* Empresa */}
          <div>
            <img 
              src="https://public.readdy.ai/ai/img_res/71fb4f6d-05d4-40e7-b3f8-9fa0dff80283.png" 
              alt="JDJ Ingeniería & Arquitectura" 
              className="h-12 w-auto mb-4"
            />
            <p className="text-gray-400 text-sm leading-relaxed">
              Soluciones integrales de <strong>ingeniería eléctrica</strong> y <strong>arquitectura</strong> en <strong>Lima</strong> y todo el <strong>Perú</strong>.
            </p>
          </div>

          {/* Servicios */}
          <div>
            <h4 className="text-lg font-bold mb-4">Servicios</h4>
            <ul className="space-y-2">
              <li><a href="#services" className="text-gray-400 hover:text-blue-400 transition-colors text-sm cursor-pointer">Ingeniería Eléctrica</a></li>
              <li><a href="#services" className="text-gray-400 hover:text-blue-400 transition-colors text-sm cursor-pointer">Arquitectura</a></li>
              <li><a href="#services" className="text-gray-400 hover:text-blue-400 transition-colors text-sm cursor-pointer">Ingeniería Integral</a></li>
              <li><a href="#services" className="text-gray-400 hover:text-blue-400 transition-colors text-sm cursor-pointer">Proyectos Industriales</a></li>
            </ul>
          </div>

          {/* Empresa */}
          <div>
            <h4 className="text-lg font-bold mb-4">Empresa</h4>
            <ul className="space-y-2">
              <li><a href="#about" className="text-gray-400 hover:text-blue-400 transition-colors text-sm cursor-pointer">Sobre Nosotros</a></li>
              <li><a href="#projects" className="text-gray-400 hover:text-blue-400 transition-colors text-sm cursor-pointer">Proyectos</a></li>
              <li><a href="#contact" className="text-gray-400 hover:text-blue-400 transition-colors text-sm cursor-pointer">Contacto</a></li>
            </ul>
          </div>

          {/* Contacto */}
          <div>
            <h4 className="text-lg font-bold mb-4">Contacto</h4>
            <ul className="space-y-3">
              <li className="flex items-start text-sm">
                <i className="ri-map-pin-line text-blue-400 mr-2 mt-0.5"></i>
                <span className="text-gray-400">Av. del Pacífico 135<br />San Miguel, Lima – Perú</span>
              </li>
              <li className="flex items-center text-sm">
                <i className="ri-phone-line text-blue-400 mr-2"></i>
                <span className="text-gray-400">+51 999 999 999</span>
              </li>
              <li className="flex items-center text-sm">
                <i className="ri-mail-line text-blue-400 mr-2"></i>
                <span className="text-gray-400">contacto@jdjingenieria.com</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Redes Sociales */}
        <div className="border-t border-gray-700 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm mb-4 md:mb-0">
            © 2024 JDJ Ingeniería & Arquitectura. Todos los derechos reservados.
          </p>
          <div className="flex space-x-4">
            <a href="#" className="w-10 h-10 flex items-center justify-center rounded-lg bg-gray-700 hover:bg-blue-600 transition-colors cursor-pointer">
              <i className="ri-facebook-fill text-lg"></i>
            </a>
            <a href="#" className="w-10 h-10 flex items-center justify-center rounded-lg bg-gray-700 hover:bg-blue-600 transition-colors cursor-pointer">
              <i className="ri-linkedin-fill text-lg"></i>
            </a>
            <a href="#" className="w-10 h-10 flex items-center justify-center rounded-lg bg-gray-700 hover:bg-blue-600 transition-colors cursor-pointer">
              <i className="ri-instagram-fill text-lg"></i>
            </a>
            <a href="#" className="w-10 h-10 flex items-center justify-center rounded-lg bg-gray-700 hover:bg-blue-600 transition-colors cursor-pointer">
              <i className="ri-youtube-fill text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}